import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth'
import { usersApi } from '../api/client'
import { useSidebar } from '../context/SidebarContext'
import { useIsMobile } from '../hooks/useIsMobile'

const C = { teal: '#2B4C5E', muted: '#6B8A91', light: '#C7D9DB', yellow: '#F2B705' }

const BASE_NAV = [
  { path: '/',           label: 'Dashboard',   icon: '📊' },
  { path: '/upload',     label: 'Add Report',  icon: '⬆️' },
  { path: '/email-list', label: 'Email Lists', icon: '📧' },
  { path: '/logs',       label: 'Logs',        icon: '🗒️' },
]

const ADMIN_NAV = [
  { path: '/users', label: 'Users', icon: '👥' },
]

export default function Sidebar() {
  const location     = useLocation()
  const navigate     = useNavigate()
  const { getToken } = useAuth()
  const { open, close } = useSidebar()
  const isMobile     = useIsMobile()
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    getToken().then(() =>
      usersApi.whoami()
        .then(r => setIsAdmin(r.data.role === 'admin'))
        .catch(() => {})
    )
  }, [])

  const nav = isAdmin ? [...BASE_NAV, ...ADMIN_NAV] : BASE_NAV
  const visible = !isMobile || open

  return (
    <aside style={{
      position:   'fixed',
      top:        64,
      left:       0,
      bottom:     0,
      width:      220,
      background: '#1a3348',
      padding:    '24px 0',
      borderRight: '1px solid #243f52',
      zIndex:     899,
      transform:  visible ? 'translateX(0)' : 'translateX(-220px)',
      transition: 'transform 0.25s ease',
    }}>
      {nav.map(({ path, label, icon }) => {
        const active = location.pathname === path
        return (
          <div key={path}
            onClick={() => { navigate(path); if (isMobile) close() }}
            style={{
              display:    'flex',
              alignItems: 'center',
              gap:        12,
              padding:    '12px 24px',
              cursor:     'pointer',
              color:      active ? C.yellow : C.light,
              background: active ? 'rgba(242,183,5,0.1)' : 'transparent',
              borderLeft: active ? `3px solid ${C.yellow}` : '3px solid transparent',
              fontSize:   14,
              fontWeight: active ? 600 : 400,
              transition: 'all 0.15s',
            }}>
            <span style={{ fontSize: 18 }}>{icon}</span>
            {label}
          </div>
        )
      })}

      <div style={{
        position: 'absolute', bottom: 24, left: 0, right: 0,
        padding: '0 24px',
      }}>
        <div style={{
          background:   'rgba(242,183,5,0.08)',
          border:       '1px solid rgba(242,183,5,0.2)',
          borderRadius: 8, padding: 12,
          fontSize: 11, color: C.muted, lineHeight: 1.6,
        }}>
          <div style={{ color: C.yellow, fontWeight: 600, marginBottom: 4 }}>Scheduler</div>
          Daily, weekly, monthly or multiple<br />
          times. Emails via SES.
        </div>
      </div>
    </aside>
  )
}
